<template>
  <div class="attachment-preview-wrap" @click.stop>
    <div class="attachment-preview" v-if="files.length !== 0">
      <span class="attachment-preview__inner" v-if="clickable">
        <a :href="file.url" target="_blank" class="attachment" v-for="(file, i) in files" :key="i">
          <span :class="classIcon">
            <Preloader v-if="isSending" is-chat-preloader width="30px" height="30px"/>

            <svg v-else width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1718 0.77417V5.6129V6.1129H11.6718H16.2258V18.1935H0.741943V0.77417H11.1718ZM12.1718 1.30549V5.1129H15.7552L12.1718 1.30549Z" fill="currentColor"/>
              <path d="M4 13L5.71429 15L10 10" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="attachment__name">{{ sliceFileName(file.name ? file.name : file.file_name) }}</span>
          <span class="attachment__size">{{ Math.round((file.size !== undefined ? file.size : file.file_size)/1000) }} Кб</span>
        </a>
      </span>

      <span class="attachment-preview__inner" v-else>
        <span class="attachment attachment_editable" v-for="(file, i) in files" :key="i">
          <span class="attachment__icon">
            <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1718 0.77417V5.6129V6.1129H11.6718H16.2258V18.1935H0.741943V0.77417H11.1718ZM12.1718 1.30549V5.1129H15.7552L12.1718 1.30549Z" fill="currentColor"/>
              <path d="M4 13L5.71429 15L10 10" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="attachment__name">{{ sliceFileName(file.name ? file.name : file.file_name) }}</span>
          <span class="attachment__size">{{ Math.round((file.size !== undefined ? file.size : file.file_size)/1000) }} кб</span>
          <button
            v-if="editable"
            class="attachment__remove"
            @click.stop="removeFile({id: file.id, index: i})"
          >
            <svg width="10" height="10" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
              <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
            </svg>
          </button>
        </span>
      </span>
    </div>

    <div class="attachment-preview" v-if="tags.length !== 0">
      <div class="attachment-title">Теги:</div>
      <div class="attachment" v-for="(tag, i) in tags" :key="i">
        <span class="attachment__tag-icon">#</span>
        <span class="attachment__tag">{{ tag }}</span>
        <span class="attachment__remove" v-if="editable" @click.stop="removeTag(i)">
          <svg width="10" height="10" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from '@/components/page/Preloader'
export default {
  name: 'AppMessageAttachmentPreview',
  components: { Preloader },
  props: {
    files: {
      type: Array,
      default: () => {
        return []
      }
    },
    tags: {
      type: Array,
      default: () => {
        return []
      }
    },
    clickable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    isSending: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      mimeTypes: ['image/jpeg', 'image/gif', 'image/pjpeg', 'image/png', 'image/svg+xml', 'image/tiff', 'image/vnd.microsoft.icon', 'image/vnd.wap.wbmp', 'image/webp']
    }
  },
  computed: {
    classIcon () {
      return this.isSending ? 'attachment__icon attachment__icon--loading' : 'attachment__icon'
    }
  },
  methods: {
    removeFile (data) {
      this.$emit('remove-file', data)
    },
    removeTag (index) {
      this.$emit('remove-tag', index)
    },
    sliceFileName (fileName) {
      return fileName.length < 30 ? fileName : `${fileName.slice(0, 30)}...`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.attachment-preview {
  display: flex;
  flex-flow: row wrap;
  /*background: $color_main;*/
  color: $font_color_second;

  &__inner {
    display: flex;
    flex-flow: row wrap;
  }
}

.attachment-title {
  font-weight: bold;
  margin-right: 12px;
}

.attachment {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-right: 12px;
  margin-bottom: 6px;

  &__icon {
    color: #9DCBEE;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    border-radius: 3px;
    width: 30px;
    height: 30px;
    background: #fff;
    transform: translateY(-2px);
    transition: .3s;

    &--loading {
      position: relative;
      background: transparent;

      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 12px;
        height: 2px;
        background: #95A4C0;
      }

      &::before {
        transform: rotate(45deg);
      }
      &::after {
        transform: rotate(-45deg);
      }
    }
  }

  &__name {
    transition: .3s;
  }

  &__size {
    flex-shrink: 0;
    margin-left: 6px;
    color: $font_color_second;
  }

  &__tag {
    color: $font_color_third;
  }

  &__remove {
    display: flex;
    align-items: center;
    margin-left: 2px;
    padding: 0;
    cursor: pointer;
    transform: translate(0, -.4em);
    transition: .3s;

    &:hover {
      color: $color_fifth;
    }
  }

  &:hover {
    .attachment__name,
    .attachment__extension,
    .attachment__icon {
      color: $color_second-dark;
    }
  }

  &_editable:hover {
    .attachment__name,
    .attachment__extension {
      color: inherit;
    }

    .attachment__icon {
      color: $color_second-light;
    }
  }
}
</style>
